// ./src/utils/nameHelpers.ts
export const buildFullName = (user: any) => {
  return user ? [user.firstName, user.lastName].join(' ').trim() : 'N/A';
};

/** Maximum allowed filename length (common filesystem limit) */
const MAX_FILENAME_LENGTH = 255;

export const makeUniqueFilename = (filename: string): string => {
  const now = new Date();
  const utc = `${now.getUTCFullYear()}${String(now.getUTCMonth() + 1).padStart(2, "0")}${String(now.getUTCDate()).padStart(2, "0")}${String(now.getUTCHours()).padStart(2, "0")}${String(now.getUTCMinutes()).padStart(2, "0")}${String(now.getUTCSeconds()).padStart(2, "0")}`;
  const offsetMin = now.getTimezoneOffset();
  const sign = offsetMin <= 0 ? "p" : "m"; // p = plus (east of UTC), m = minus (west)
  const absOffset = Math.abs(offsetMin);
  const offsetHrs = String(Math.floor(absOffset / 60)).padStart(2, "0");
  const offsetMins = String(absOffset % 60).padStart(2, "0");
  const timestamp = `_${utc}_${sign}${offsetHrs}${offsetMins}`;

  const dotIndex = filename.lastIndexOf(".");
  if (dotIndex === -1) {
    const candidate = `${filename}${timestamp}`;
    return candidate.length <= MAX_FILENAME_LENGTH ? candidate : filename;
  }

  const baseName = filename.substring(0, dotIndex);
  const extension = filename.substring(dotIndex);
  const candidate = `${baseName}${timestamp}${extension}`;

  return candidate.length <= MAX_FILENAME_LENGTH ? candidate : filename;
};